// src/layouts/events/create/components/data/useFieldsData.js
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../../../../config";
import { useTranslation } from "react-i18next";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;

const useFieldsData = () => {
  const { t } = useTranslation();
  const [fields, setFields] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await axios.get(`${API_URL}/eventsFormLists`, {
          headers: {
            "X-API-Key": API_TOKEN,
            "Content-Type": "application/json",
          },
        });

        setFields(response.data);
        setLoading(false);
      } catch (err) {
        // Use centralized copy
        setError(t("events.create.errorLoadingFields"));
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { fields, loading, error };
};

export default useFieldsData;
